import { render, staticRenderFns } from "./d-comment-entry-removal.vue?vue&type=template&id=0e13999c&"
import script from "./d-comment-entry-removal.vue?vue&type=script&lang=js&"
export * from "./d-comment-entry-removal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports